import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from '@masar/common/models';
import { permissionList } from '@masar/common/constants';

@Component({
    selector: 'app-user-link',
    templateUrl: './user-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class UserLinkComponent {
    @Input() public item: User;
    public permissionList = permissionList;
}
